import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const YumekukanKumiaiKohoKbn = props => {
  return <Dropdown.Static kubunKey='yumekukan_kumiai_koho_kbn' {...props} />
}
